// extracted by mini-css-extract-plugin
module.exports = {"productGridItem":"ProductGridItem_productGridItem__SqvCo","title":"ProductGridItem_title__TYiRw"};